
import React from 'react';
import { SubscriptionDetailsDialog } from './SubscriptionDetailsDialog';

interface SubscriptionDetailsPanelProps {
  subscriptionId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onStatusChange: (id: string, status: 'active' | 'paused' | 'cancelled') => Promise<void>;
  onDelete: (id: string) => Promise<void>;
  // Пропсы для редактирования
  onEdit: () => void;
  isEditMode: boolean;
  onCloseEditMode: () => void;
  loading: boolean;
}

export function SubscriptionDetailsPanel({
  subscriptionId,
  open,
  onOpenChange,
  onStatusChange,
  onDelete,
  onEdit,
  isEditMode,
  onCloseEditMode,
  loading
}: SubscriptionDetailsPanelProps) {
  // Компонент просто передает все пропсы диалогу деталей подписки
  return (
    <SubscriptionDetailsDialog
      subscriptionId={subscriptionId}
      open={open}
      onOpenChange={onOpenChange}
      onStatusChange={onStatusChange}
      onDelete={onDelete}
      onEdit={onEdit}
      isEditMode={isEditMode}
      onCloseEditMode={onCloseEditMode}
      loading={loading}
    />
  );
}
